import { render, staticRenderFns } from "./AFormAttachment.vue?vue&type=template&id=0f6493d8&scoped=true&"
import script from "./AFormAttachment.vue?vue&type=script&lang=js&"
export * from "./AFormAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6493d8",
  null
  
)

export default component.exports